// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"d067fd899a25d7cf6d0f","453":"3c143d405800cf996987"}[chunkId] + ".js";
};